"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleOnGoodstrapDragEvent = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var throttle_1 = tslib_1.__importDefault(require("lodash/throttle"));
var custom_event_1 = tslib_1.__importDefault(require("custom-event")); // TODO: FET-772 Remove IE-specific polyfills, upgrade blocked dependencies
var fireGoodstrapDragEvent = function (node, windowInstance) {
    if (windowInstance === void 0) { windowInstance = { dispatchEvent: function (_event) { return true; } }; }
    windowInstance.dispatchEvent(new custom_event_1.default("goodstrap.drag", {
        // this will close dropdowns with closeOnMouseDrag=true
        bubbles: true,
        detail: {
            node: node,
        },
    }));
};
/**
 * This is custom dom goodstrap event, it is used by Overlay to handle CloseOnParentDrag
 * This event is throttled by default
 * @internal
 */
exports.handleOnGoodstrapDragEvent = throttle_1.default(function () { return fireGoodstrapDragEvent(document.body, window); }, 500);
//# sourceMappingURL=drag.js.map